module.exports = __webpack_public_path__ + "assets/8fa99a7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sport-yellow.png
// module id = 107
// module chunks = 0